import { Component, Input } from "@angular/core";
import { IFundTotal } from "@tylertech/tyler-api-types";
@Component({
    selector: "fund-recap-row",
    templateUrl: "./fundRow.tmpl.html",
    standalone: false
})
export class FundRecapRowComponent
{
    @Input() fund: IFundTotal;
    @Input() header: boolean;
}
